"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const getDefinablesCount_1 = __importDefault(require("./getDefinablesCount"));
const getImageSourcesCount = () => (0, getDefinablesCount_1.default)("ImageSource");
exports.default = getImageSourcesCount;
